export default __webpack_public_path__ + "49f37b1272ad48b2df24c5538133d221.jpg";